import { FeatureCards } from './components/feature-cards';
import { QuickStatsRow } from './components/quick-stats-row';
import { RecentActivity } from './components/recent-activity';
import { WelcomeHero } from './components/welcome-hero';

import { Skeleton } from '@/components/ui/skeleton';
import { useTrainingProgress } from '@/hooks/use-training-progress';

export function TrainingHubPage() {
  const { data: progress, isLoading } = useTrainingProgress();

  if (isLoading) {
    return (
      <div className="space-y-6">
        <Skeleton className="h-48 w-full" />
        <div className="grid gap-4 sm:grid-cols-3">
          <Skeleton className="h-24" />
          <Skeleton className="h-24" />
          <Skeleton className="h-24" />
        </div>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-5xl space-y-6">
      <WelcomeHero progress={progress} />
      <QuickStatsRow progress={progress} />
      <FeatureCards progress={progress} />
      <RecentActivity progress={progress} />
    </div>
  );
}
